import { MenuItem, TextField } from "@mui/material";
import type { JSX } from "react";

/**
 * Compact filter dropdown styled like a Material chip — pill shape. Empty value
 * renders the "All …" option. Extracted from `TicketListPage.tsx`.
 */
export function FilterSelect({
  value,
  onChange,
  placeholder,
  options,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  options: { value: string; label: string }[];
}): JSX.Element {
  return (
    <TextField
      select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      SelectProps={{ displayEmpty: true, "aria-label": placeholder }}
      sx={{ minWidth: 140, "& .MuiOutlinedInput-root": { borderRadius: 999 } }}
    >
      <MenuItem value="">All {placeholder.toLowerCase()}</MenuItem>
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
